<template>
    <div class="computerBox">
        <!-- <topMenu /> -->
        <!-- <backPage :title="$route.meta.title" /> -->
        <topBox :title="$route.meta.title" />
        <!-- 内容区 -->
        <div class="px-[36px] w-full mt-[80px]">

                <!-- <div class="flex justify-center">
                    <h1 class="color-y text-m16">{{ $t('but.register') }}</h1>
                </div> -->
                
                <div class="">
                    <div class="my-1">
                        <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('title.account') }}</h1>
                        <input
                            type="text"
                            class="block w-full px-[35px]  py-[15px] border rounded-full bg-white shadow-lg placeholder-gray-400 text-gray-700 focus:ring-1  focus:outline-none text-ms"
                            :placeholder="$t('placeholder.user')"
                            maxlength="22"
                            x-model="cardholder"
                            v-model="form.account"
                        />
                    </div>
                    <div class="my-1">
                        <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('title.password') }}</h1>
                        <input
                            type="password"
                            class="block w-full px-[35px]  py-[15px] border rounded-full bg-white shadow-lg placeholder-gray-400 text-gray-700 focus:ring-1  focus:outline-none text-ms"
                            :placeholder="$t('placeholder.password')"
                         
                            maxlength="19"
                            v-model="form.password"
                        />
                    </div>
                    <div class="my-1">
                        <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('title.confirmPassword') }}</h1>
                        <input
                            type="password"
                            class="block w-full px-[35px]  py-[15px] border rounded-full bg-white shadow-lg placeholder-gray-400 text-gray-700 focus:ring-1  focus:outline-none text-ms"
                            :placeholder="$t('placeholder.confirmPassword')"
                    
                            v-model="form.confirm"
                        />
                    </div>
                    <!-- <div class="my-1">
                        <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('title.inviteCode') }}</h1>
                        <input
                            type="text"
                            class="block w-full px-[35px] py-[15px] border rounded-full bg-white shadow-lg placeholder-gray-400 text-gray-700 focus:ring-1 focus:outline-none text-ms"
                            :class="{ 'bg-slate-100 cursor-not-allowed': inviteFromLink }"
                            :placeholder="$t('placeholder.invitation')"
                            maxlength="36"
                            :readonly="inviteFromLink"
                            v-model="form.invite"
                        />
                        <p v-if="inviteFromLink" class="mt-2 text-xs text-slate-400">{{ $t('text.inviteFromLink') }}</p>
                    </div> -->
                </div>

              
                <!-- 滑块验证组件 -->
                <SlideVerify @success="isVerified = true" />
                
       
                <div class="mt-0 py-[25px]">
                    <button
                        class="block w-full px-5  py-[15px] border rounded-full butSubmit text-white shadow-lg placeholder-gray-400 text-gray-700 focus:ring-1  focus:outline-none text-xs-xs"
                        x-bind:disabled="!isValid"
                        x-on:click="onSubmit()"
                        @click="runSubmit"
                    >
                        {{ $t('but.continue') }}
                    </button>
                </div>

     
                <div class="text-xs-xs flex justify-center">
                    <router-link to="/computer/login">
                        <div class="color-y text-m14">{{ $t('text.loginTip') }}{{ $t('but.login') }}</div>
                    </router-link>
                </div>

        </div>
        <mainMenu />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { ref, watch } from 'vue'
import topBox from "@/components/computer/TopBox.vue"
// import topMenu from "@/components/computer/TopMenu.vue"
import mainMenu from "@/components/computer/MainMenu.vue"
import axios from 'axios'
import { layer } from "vue3-layer"
import SlideVerify from '@/components/SlideVerify.vue'

import Message from '@/components/message'
import router from "@/router/index.js"
// 注册全局变量
import global from '@/assets/js/global'
import { useGlobalStore } from '@/assets/js/globalStore'
export default {
    components: {
        // topMenu,
        // backPage,
        topBox,
        mainMenu,
        SlideVerify
    },
    setup() {
        // 显示失败信息
        const showMessage1 = () => {
            Message({
                msg: '34',
                type: 'success'
            })
        }
        // 显示成功信息
        const showMessage2 = () => {
            Message.error('45')
        }

        // 获取临时令牌函数：操作注册帐号的API请求时需要携带临时令牌
        const getApiToken = () => {
            // Ws 还没有绑定客户端 不可以发起请求
            if (!global.isBind || 1 !== global.wssConnection.readyState) {
                console.log('连接未就绪，请稍后重试')
                return false
            }
            // 监听 WS 服务端的响应 对结果进行处理 结果一到位就会响应
            getApiTokenWork() 
            // 向 WS 服务端发起登录请求
            global.wssConnection.send(
                JSON.stringify({'event':'task', 'task':'member.get.api.reg.token', 'type': 'reg', 'account':global.token, 'id':global.wssConID})
            )
        }

        const time = ref(100)
        const timeObj = ref(null)
        // 以百分之一秒的速度递归 监听WS服务端的响应 判断是否登录成功
        const getApiTokenWork = () => {
            timeObj.value = setTimeout(() => {
                if (false!==global.response && 'apiToken'===global.response.event ) { // 确保全局WS响应数据有值 并且是本请求对应的响应数据 才可以进行处理
                    if (0===global.response.data.code) wsGetSuccess() // 正确处理
                    global.response = false // 处理完数据 要把数据清空
                    clearTimeout(timeObj) // 清除定时器，因为已经处理完数据了
                } else {
                    getApiTokenWork() // 什么时候结束递归？得到 WS 响应的结果时不再递归，即 global.response = false 时就不再递归
                }
            }, time)
        }

        // WS 获取临时令牌成功后的处理函数
        const wsGetSuccess = () => {
            localStorage.setItem('tokenApi', global.response.data.token)
        }

        const isVerified = ref(false) // 滑块验证是否通过
        const handleRegister = () => { // 滑块验证处理逻辑
            var status = true
            if (!isVerified.value) {
                status = false
            }
            return status
        }
        // 监听 isVerified 的变化
        watch(isVerified, (newValue, oldValue) => {
            // console.log(`newValue: ${newValue}, oldValue: ${oldValue}`)
            if (newValue !== oldValue && newValue === true) {
                getApiToken() // 获取临时令牌，用来注册帐号。
            }
        })

        return {
            showMessage1,
            showMessage2,
            isVerified, handleRegister
        }
    },
    data() {
        return {
            lang: '',
            form: {
                account: '',
                password: '',
                confirm: '',
                invite: ''
            },
            inviteFromLink: false,
            verified: false, // 是否弹出滑块验证提示
        }
    },
    mounted() {
        // 切换语言
        const { locale } = useI18n()  // 从国际化中取出配置项 locale 因为初始化时 用户没有指定语种 要使用系统默认的语种
        this.lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : locale.value // 如果用户有选择特定语种 就使用用户指定的 不然就使用系统默认的
        locale.value = this.lang
        this.initInviteFromQuery()  // 初始化邀请码
        return {}
    },
    watch: {
        '$route.query.invite'() {
            this.initInviteFromQuery()
        },
        '$route.params.uuid'() {
            this.initInviteFromQuery()
        },
    },
    methods: {
        /**
         * 是否为合法邀请码（会员 uuid，固定 36 位）
         * 播放页路由占位符 "uuid"、空串、0 都不能当邀请码，否则会触发后端 invite 校验。
         */
        isValidInviteCode(value) {
            const code = String(value ?? '').trim()
            if (!code || code === '0' || code.toLowerCase() === 'uuid') {
                return false
            }
            return code.length === 36
        },
        resolveInviteCode() {
            const candidates = [
                this.$route.params.uuid,
                this.$route.query.invite,
                useGlobalStore().invite,
                this.form.invite,
            ]
            for (const item of candidates) {
                const code = String(item ?? '').trim()
                if (this.isValidInviteCode(code)) {
                    return code
                }
            }
            return ''
        },
        initInviteFromQuery() {
            const invite = this.resolveInviteCode()
            if (invite) {
                this.form.invite = invite
                this.inviteFromLink = true
                useGlobalStore().setInvite(invite)
            } else {
                // 清掉被播放页占位符等污染的 store，避免注册时误带 invite
                this.form.invite = ''
                this.inviteFromLink = false
                useGlobalStore().setInvite(0)
            }
        },
        runSubmit() {
            if (!this.handleRegister()) return false // 先要通过滑块验证
            const invite = this.resolveInviteCode()
            // 无有效邀请码时不要传 invite 字段，后端才会跳过 36 位校验
            const payload = {
                app_id: global.app_id,      // 用来区分不同系统的 app_id
                app_key: global.app_key,    // 用来区分不同系统的 app_key
                account: this.form.account,
                password: this.form.password,
                confirm: this.form.confirm,
                token_api: localStorage.getItem('tokenApi')
            }
            if (invite) {
                payload.invite = invite
            }
            axios.post(
                '/api/register',
                payload,
                {
                    headers: {
                        // 'Content-Type': 'multipart/form-data'
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang
                    }
                }
            )
            .then(function (response) {
                if (0===response.data.code) {
                    localStorage.setItem('token', response.data.data.token)
                    localStorage.setItem('isLogin', true) // 标识为已经登录 
                    localStorage.setItem('isAgent', response.data.data.is_agent)

                    global.token = response.data.data.token
                    global.isLogin = true
                    global.isAgent = response.data.data.is_agent

                    const globalStore = useGlobalStore()    
                    globalStore.setLogin(true)  // 保证写入时，写入的是布尔值
                    globalStore.setIsAgent(response.data.data.is_agent)  // 保证写入时，写入的是布尔值
                    
                    router.push({
                        path: '/computer/user',
                        query: {
                            msg: 'reg account'
                        }
                    })
                } else {
                    layer.msg( response.data.data.msg )
                }
            })
            .catch(function (error) {
                console.log(error)
            })
        }
    }

}
</script>

<style lang="scss" scoped>

</style>